export default __webpack_public_path__ + "static/media/myprojectpic.c12ec3c3.jpg";